<script setup lang="ts">
/**
 * 实名认证 in the account-ID row: the shield and the words, both in the
 * status's own colour — green once verified, blue while it is checked,
 * orange while not verified and red when refused (with 去认证) — never the
 * theme colour. Used by the workplace's account card and the navbar's
 * account panel, so both say it alike.
 */
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import type { RouteLocationRaw } from 'vue-router'
import { IconSafe } from '@arco-design/web-vue/es/icon'
import { useAuthStore } from '@/store/auth'
import { REALNAME_PAGE, realnameOf } from '@/utils/realname'

const emit = defineEmits<{ go: [to: RouteLocationRaw] }>()
const { t } = useI18n()
const auth = useAuthStore()
const rn = computed(() => realnameOf(auth.user, t))
</script>

<template>
  <span class="rn-note">
    <span class="rn-sep" aria-hidden="true">·</span>
    <span class="rn-status" :class="rn.tone">
      <IconSafe class="rn-shield" aria-hidden="true" />
      <span class="rn-text">{{ rn.label }}</span>
    </span>
    <a v-if="rn.act" class="rn-go" @click="emit('go', REALNAME_PAGE)">{{ t('navbar.rnGo') }}</a>
  </span>
</template>

<style scoped>
.rn-status {
  display: inline-flex;
  align-items: center;
  gap: 4px;
}
/* The status's colours, not the theme's: Arco's success, processing,
   warning and danger. */
.rn-shield {
  flex: none;
  font-size: 15px;
  color: var(--color-text-4);
}
.ok .rn-shield,
.ok .rn-text {
  color: rgb(var(--green-6));
}
.pending .rn-shield,
.pending .rn-text {
  color: rgb(var(--arcoblue-6));
}
.warn .rn-shield {
  color: rgb(var(--orange-6));
}
.bad .rn-shield {
  color: rgb(var(--red-6));
}
.rn-note {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  white-space: nowrap;
}
.rn-sep {
  color: var(--color-text-4);
}
.rn-text {
  color: var(--color-text-2);
}
.warn .rn-text {
  color: rgb(var(--orange-6));
}
.bad .rn-text {
  color: rgb(var(--red-6));
}
.rn-go {
  color: rgb(var(--primary-6));
  cursor: pointer;
}
.rn-go:hover {
  color: rgb(var(--primary-5));
}
</style>
